import EnumService from '../EnumService'

export default class ContribuicaoEnumService extends EnumService{

    constructor(){
        super('enumContribuicao');
    }
  
  }